import {
  THookSelectorFetchDataInfo,
  TSelector,
  useGenFetchDataSelector,
} from 'redux/rootSelectors';
import { NotificationState } from './reducer';
import { NotificationMessages } from './types';

export const selectorNotificationMessages: TSelector<
  NotificationState['messages']
> = ({ notificationReducer }) => notificationReducer.messages;

export const useNotificationMessages: THookSelectorFetchDataInfo<
  NotificationMessages
> = () => useGenFetchDataSelector(selectorNotificationMessages);
